const PERMISSION_CLAIM_KEYS = [
  'permission',
  'permissions',
  'scope',
  'scp',
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/permission',
];

export const normalizePermissions = (value: unknown): string[] => {
  if (!value) return [];

  if (Array.isArray(value)) {
    return Array.from(new Set(value.flatMap((item) => normalizePermissions(item))));
  }

  if (typeof value === 'string') {
    return value
      .split(/[\s,;]+/)
      .map((item) => item.trim().toLowerCase())
      .filter(Boolean);
  }

  return [];
};

export const extractPermissionsFromToken = (token: string | null | undefined): string[] => {
  if (!token) return [];

  const parts = token.split('.');
  if (parts.length < 2) return [];

  try {
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const paddedPayload = payload.padEnd(payload.length + ((4 - (payload.length % 4)) % 4), '=');
    const decoded = JSON.parse(atob(paddedPayload)) as Record<string, unknown>;
    const permissions = PERMISSION_CLAIM_KEYS.flatMap((key) =>
      normalizePermissions(decoded[key]),
    );

    return Array.from(new Set(permissions));
  } catch {
    return [];
  }
};

export const hasRequiredPermission = (
  permissions: string[] | null | undefined,
  required: string,
): boolean => {
  const normalizedRequired = required.trim().toLowerCase();
  return (permissions ?? []).some((permission) => permission.toLowerCase() === normalizedRequired);
};

export const hasAnyPermission = (
  permissions: string[] | null | undefined,
  required: string[],
): boolean => required.some((permission) => hasRequiredPermission(permissions, permission));
